export const geolocationApi = (http) => {
  return {
    find: async () => {
      return http.get('/api/ip-geolocation');
    },
  };
};
